// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  color: #000000;
  /* text-decoration: none; */
}
body {
  font-size: 14px !important;
}
input {
  font-size: 14px !important;
}
p {
  font-size: 14px;
}
table {
  font-size: 14px;
}
div {
  font-size: 14px;
}
a {
  font-size: 14px;
}
.tooltip1 {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip1 .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 1 !important;
  transition: opacity 0.3s;
}

.tooltip1 .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltip1:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.img-fluid {
  width: 100% !important;
  height: 375px;
  border-radius: var(--bs-border-radius);
}
.img-fluid-thumnail {
  width: 100% !important; /*160px */
  height: 87px;
  border-radius: var(--bs-border-radius);
  max-width: 150px;
}
.img-fluid-eventCard {
  width: 100% !important;
  height: 200px;
  border-radius: 8px 8px 0px 0px;
  padding: 2px;
}
.img-fluid-eventCard-small {
  width: 100% !important;
  height: 120px;
}

.container-fluid .img-fluid-thumnail {
  height: 40px;
}
.container-fluid .img-fluid {
  height: 180px;
}
.carousel-item {
  height: 350px;
}
/* .numberWithoutArrowkey {
  /* Chrome, Safari, Edge, Opera 
  -webkit-appearance: none;
  margin: 0;

  /* Firefox 
  -moz-appearance: textfield;
} */
.quantity {
  position: relative;
}
.quantity {
  width: 70px;
  height: 42px;
  line-height: 1.65;
  float: left;
  display: block;
  padding: 0;
  margin: 0;
  padding-left: 20px;
  border: none;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
  font-size: 1rem;
  border-radius: 4px;
}

.quantity:focus {
  outline: 0;
}

.quantity:active {
  background: #eaeaea;
}

.modal-open {
  overflow: hidden;
}
.text-red-600 {
  color: red;
}
.event-proce span {
  padding: 3px 12px;
  cursor: pointer;
}
.event-proce {
  cursor: pointer;
}
.event-proce .green-b {
  border: #27d4ab 2px solid !important;
  padding: 3px 12px;
}
.event-proce .completed {
  padding: 3px 12px;
}
.org-main-contain {
  padding: 4px;
}
.font-weight-semibold {
  margin: 17px;
}
.home-banner .next-btn {
  margin-right: -46px;
}
.home-banner .pre-btn {
  margin-left: -46px;
}
.cat-name a {
  font-size: 24px;
  font-weight: 500;
  text-decoration: none;
  color: #000;
}
.home-banner-img {
  margin-top: 10px;
}
.container-fluid .cePreview {
  width: 100%;
}
/*destop and mobile */
.cat-img-thumbnail {
  width: 150px;
  height: 120px;
}
.col-lg-3 {
  width: 32%;
}
/*custom-dropdown .dropdown-menu*/
#avatar img {
  /* This image is 687 wide by 1024 tall, similar to your aspect ratio */
  /* background-image: url("https://i.stack.imgur.com/Dj7eP.jpg"); */

  /* make a square container */
  width: 40px;
  height: 40px;

  /* fill the container, preserving aspect ratio, and cropping to fit */
  background-size: cover;

  /* center the image vertically and horizontally */
  background-position: top center;

  /* round the edges to a circle with border radius 1/2 container size */
  border-radius: 50%;
}
.custom-dropdown .dropdown-menu a {
  text-decoration: none;
  color: #000;
}
.custom-dropdown {
  margin-top: 10px !important;
  margin-left: -210px !important;
}
.custom-dropdown .dropdown-menu {
  width: 240px;
  height: 280px;
}

.custom-dropdown .dropdown-menu a .icon {
  margin-right: 15px;
  display: inline-block;
}
.custom-dropdown .menu-heading {
  font-size: 14px;
  color: #000000;
  padding-left: 20px;
  padding-right: 20px;
  cursor: text;
  font-weight: 550;
}
.custom-dropdown .dropdown-menu a {
  font-size: 14px;
  padding: 8px 20px;
  position: relative;
  color: #000;
}

.custom-dropdown svg {
  width: 25px;
  height: 25px;
  stroke: var(--gray-darklight);
}
.custom-dropdown svg:hover {
  fill: rgb(8, 23, 71);
  stroke: var(--Primary-Color-brand-5C6ACA);
}
.custom-backdrop {
  z-index: -1;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}
.user-profile .nav-item.active,
.user-profile .nav-item.active .nav-link {
  font-weight: 500 !important;
  color: var(--Primary-Color-brand-5C6ACA) !important;
  border-bottom-color: currentcolor !important;
  stroke: var(--Primary-Color-brand-5C6ACA) !important;
}
.table-responsive .img-fluid {
  width: 100%;
  height: 50px;
}
.offcanvas {
  width: auto !important;
}

.sidebar .active {
  color: var(--Primary-Color-Dark-000639);
  background-color: var(--white);
  border-radius: 6px;
  fill: var(--Primary-Color-Dark-000639);
  stroke: var(--Primary-Color-Dark-000639);
  padding: 20px;
}
.sidebar .list-group a {
  background: none;
}
.sidebar .list-group .active a {
  color: red !important;
}
.rightside-bar {
  /* height: auto !important; */
}
.rightside-bar .list-group-item a {
  color: #f9fafb;
  font-size: 14px;
  font-weight: 400;
  padding: 0px;
}
.topmargin {
  margin-top: 98px;
}
.clearBoth {
  clear: both;
}
/*--------component tabel arrow------------*/
.arrow {
  border: solid #8d8181;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
  margin-left: 4px;
  cursor: pointer;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.event-card-body h6 a,
.event-card-body .card-text-b a {
  color: #000;
  text-decoration: none;
}
.event-card-body .card-text-b a,
.txtBlue a {
  color: #4983e2;
}
.logo img {
  width: 85px !important;
}
.mdnSlCityEvents .cat-name {
  margin-left: 30px;
}
.mdnSlCityEvents .text-end {
  margin-right: 30px;
}
.cityPopup img {
  width: 120px;
  height: 120px;
  margin-left: 10px;
}
.table-responsive {
  font-size: 14px;
  background-color: var(--bs-secondary-bg-subtle) !important;
}
.table-responsive h1 {
  font-size: 16px;
}
.table-responsive th {
  font-size: 14px;
  font-weight: 400;
}
.table-responsive .btn {
  font-size: 14px !important;
}
.container {
  min-height: 70vh;
}
.footer {
}
.mdnEDTable {
  text-align: left !important;
  margin-left: 20px;
  width: 90%;
}
.mdnEDTable span {
  font-weight: 600;
}
.modal-dialog {
  top: 20%;
}
.recommend {
  margin-top: 10px;
}
.mdncardTitle {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
/*----------mobile ------*/
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .event-card-body h6,
  .event-card-body .card-text {
    font-size: 14px;
  }
  .mdnCreateOrgPro .w-50 {
    width: 100% !important;
  }
  .img-fluid-thumnail {
    width: 100% !important;
    height: 45px;
    max-width: 80px;
    border-radius: var(--bs-border-radius);
  }
  .col-lg-3 {
    width: auto;
  }
  .dropdown-menu {
    border: none !important;
  }
  .cat-img-thumbnail {
    width: 100px;
    height: 80px;
  }
  .cat-name a {
    font-size: 17px;
  }
  .img-fluid-eventCard {
    /*     height: auto; */
  }
  .img-fluid-eventCard-small {
    border-radius: var(--bs-border-radius);
    height: 60px;
  }
  .topmargin {
    margin-top: 150px;
  }
  .recommend {
    margin-top: 10px;
  }
  .mdnrecommend {
    margin: 0px !important;
    padding: 0px !important;
  }
  .mdnrecdviewall {
    max-width: 120px !important;
  }
  .pre-btn button {
    margin-left: -8px;
  }
  .next-btn button {
    margin-right: -8px !important;
  }
  .ffSlider .pre-btn,
  .ffSlider .next-btn,
  .mdnCreateEvent {
    display: none;
  }
  .mdnViewAll,
  .mdnWelcome {
    display: block !important;
  }

  #avatar {
    margin-right: 12px;
  }
  .user-profile .nav-underline {
    --bs-nav-underline-gap: 0rem;
  }
  .mdnOrgMst .rightside-bar,
  .mdnDashboard {
    display: none;
  }
  .mdnOrgMst .maincontain-width {
    width: 100%;
  }
  .user-profile .nav-item {
    padding: 0px;
  }
  .user-profile .nav-item button {
    font-size: 12px;
  }
  .user-profile .nav-item img {
    width: 25px;
  }
  .mdnSlCityEvents .cat-name {
    margin-left: 0px;
  }
  .mdnSlCityEvents .text-end {
    margin-right: 0px;
  }
  .cityPopup img {
    width: 100px;
    height: 100px;
    padding: 4px;
    margin: 0px;
  }
  .carousel-item {
    height: 250px;
  }
  .carousel-inner img {
    width: 100%;
    height: 250px !important;
  }

  .mdnTableTitle {
    /* width: 210% !important; */
  }
  .hide-on-mobile {
    display: none;
  }
}

@media (max-width: 575.98px) {
  .all-city {
    padding: 8px !important;
    font-size: 14px !important;
  }
}

@media only screen and (max-width: 450px) {
  .all-city {
    padding: 8px !important;
    font-size: 9px !important;
  }

  .user-profile .nav-underline {
    --bs-nav-underline-gap: 0rem;
  }
  .mdnOrgMst .rightside-bar,
  .mdnDashboard {
    display: none;
  }
  .mdnOrgMst .maincontain-width {
    width: 100%;
  }
  .user-profile .nav-item {
    padding: 0px;
  }
  .user-profile .nav-item button {
    font-size: 12px;
  }
  .user-profile .nav-item img {
    width: 25px;
  }
  .cat-name a {
    font-size: 13px;
  }
}
@media only screen and (max-width: 410px) {
  .all-city {
    padding: 2px !important;
    font-size: 9px !important;
  }
}
@media only screen and (min-width: 600px) and (min-width: 700px) and (max-width: 900px) {
  .order-2 {
    order: none;
  }
}
/* vertical mobile screen*/
@media only screen and (min-width: 640px) and (max-width: 999px) {
  .mdnViewAll,
  .mdnWelcome {
    display: block !important;
  }
  .mdnSearch {
    position: absolute;
    margin: 14%;
  }
  .topmargin {
    margin-top: 50px;
  }
  .user-profile .nav-underline {
    --bs-nav-underline-gap: 0rem;
    margin-top: 30px;
  }
  .mdnOrgMst .rightside-bar,
  .mdnDashboard {
    display: none;
  }
  .mdnOrgMst .maincontain-width {
    width: 100%;
  }
}
/*
@media only screen and (max-width: 350px) and (max-width: 600px) {
  .topmargin {
    margin-top: 150px;
  }
}*/

.pencil-icon {
  position: relative;
  top: -23px;
  right: -10px;
  transform: translate(-50%, -50%);
}

.verify-button {
  cursor: pointer;
}
.login-dmenu .bi::before {
  font-size: 30px;
}

.hidden {
  display: none;
}

.loaderBreakup {
  width: 25px;
  height: 25px;
  border: 2px solid #fff;
  border-bottom-color: #ef395f;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin-top: 10px;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.event-details-container-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
}

.event-details-left-custom {
  display: flex;
  flex-direction: column;
}

.tags-container-custom {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tag-item-custom {
  margin: 0.2rem;
}

.event-details-right-custom {
  display: flex;
  align-items: center;
}

.price-container-custom {
  display: flex;
  align-items: center;
}

.price-custom {
  background-color: black;
  color: white;
  padding: 0.5rem 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  min-width: 100px;
  margin-right: 0.5rem;
  font-size: 18px;
  border-radius: 5px;
  font-weight: 550;
}

.book-btn-custom {
  background-color: black;
  color: white;
  padding: 0.5rem 5rem;
  height: 50px;
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.book-btn-custom:hover {
  background-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
}

@media (max-width: 768px) {
  .event-details-container-custom {
    flex-direction: column;
    align-items: flex-start;
    /* padding-bottom: 60px; Ensure content doesn't hide behind the fixed button */
  }

  .event-details-right-custom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    padding: 1rem;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    justify-content: space-between;
    z-index: 1000;
  }

  .price-container-custom {
    width: 100%;
    justify-content: space-between;
  }

  .price-custom,
  .book-btn-custom {
    width: 48%; /* Adjust the width to ensure both elements fit side by side */
    font-size: 14px;
    padding: 0rem 0rem;
  }

  .mobile-view {
    flex-direction: column; /* vertically on mobile */
    justify-content: flex-start;
    align-items: flex-start;
  }
}

.org-table td {
  text-align: left;
  vertical-align: middle; /* Center content vertically */
}
`, "",{"version":3,"sources":["webpack://./src/css/style-overlap.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,sBAAsB,EAAE,SAAS;EACjC,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;;;;;;GAOG;AACH;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA,qBAAqB;AACrB;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA,iCAAiC;AACjC;EACE,sEAAsE;EACtE,kEAAkE;;EAElE,4BAA4B;EAC5B,WAAW;EACX,YAAY;;EAEZ,qEAAqE;EACrE,sBAAsB;;EAEtB,iDAAiD;EACjD,+BAA+B;;EAE/B,sEAAsE;EACtE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;AACT;AACA;;EAEE,2BAA2B;EAC3B,mDAAmD;EACnD,4CAA4C;EAC5C,oDAAoD;AACtD;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,wCAAwC;EACxC,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA,4CAA4C;AAC5C;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;AACA;;EAEE,WAAW;EACX,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;AACA;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB;;IAEE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,sCAAsC;EACxC;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sCAAsC;IACtC,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;;;IAGE,aAAa;EACf;EACA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;EACA;;IAEE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;EAC9B;EACA;;IAEE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA,0BAA0B;AAC1B;EACE;;IAEE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;EACA;;IAEE,aAAa;EACf;EACA;IACE,WAAW;EACb;AACF;AACA;;;;;EAKE;;AAEF;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,2EAA2E;AAC7E;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,8EAA8E;EAChF;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,aAAa;IACb,yCAAyC;IACzC,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;;IAEE,UAAU,EAAE,8DAA8D;IAC1E,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB,EAAE,yBAAyB;IACjD,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,sBAAsB,EAAE,8BAA8B;AACxD","sourcesContent":["a {\n  color: #000000;\n  /* text-decoration: none; */\n}\nbody {\n  font-size: 14px !important;\n}\ninput {\n  font-size: 14px !important;\n}\np {\n  font-size: 14px;\n}\ntable {\n  font-size: 14px;\n}\ndiv {\n  font-size: 14px;\n}\na {\n  font-size: 14px;\n}\n.tooltip1 {\n  position: relative;\n  display: inline-block;\n  border-bottom: 1px dotted black;\n}\n\n.tooltip1 .tooltiptext {\n  visibility: hidden;\n  width: 120px;\n  background-color: #555;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -60px;\n  opacity: 1 !important;\n  transition: opacity 0.3s;\n}\n\n.tooltip1 .tooltiptext::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #555 transparent transparent transparent;\n}\n\n.tooltip1:hover .tooltiptext {\n  visibility: visible;\n  opacity: 1;\n}\n\n.img-fluid {\n  width: 100% !important;\n  height: 375px;\n  border-radius: var(--bs-border-radius);\n}\n.img-fluid-thumnail {\n  width: 100% !important; /*160px */\n  height: 87px;\n  border-radius: var(--bs-border-radius);\n  max-width: 150px;\n}\n.img-fluid-eventCard {\n  width: 100% !important;\n  height: 200px;\n  border-radius: 8px 8px 0px 0px;\n  padding: 2px;\n}\n.img-fluid-eventCard-small {\n  width: 100% !important;\n  height: 120px;\n}\n\n.container-fluid .img-fluid-thumnail {\n  height: 40px;\n}\n.container-fluid .img-fluid {\n  height: 180px;\n}\n.carousel-item {\n  height: 350px;\n}\n/* .numberWithoutArrowkey {\n  /* Chrome, Safari, Edge, Opera \n  -webkit-appearance: none;\n  margin: 0;\n\n  /* Firefox \n  -moz-appearance: textfield;\n} */\n.quantity {\n  position: relative;\n}\n.quantity {\n  width: 70px;\n  height: 42px;\n  line-height: 1.65;\n  float: left;\n  display: block;\n  padding: 0;\n  margin: 0;\n  padding-left: 20px;\n  border: none;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);\n  font-size: 1rem;\n  border-radius: 4px;\n}\n\n.quantity:focus {\n  outline: 0;\n}\n\n.quantity:active {\n  background: #eaeaea;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n.text-red-600 {\n  color: red;\n}\n.event-proce span {\n  padding: 3px 12px;\n  cursor: pointer;\n}\n.event-proce {\n  cursor: pointer;\n}\n.event-proce .green-b {\n  border: #27d4ab 2px solid !important;\n  padding: 3px 12px;\n}\n.event-proce .completed {\n  padding: 3px 12px;\n}\n.org-main-contain {\n  padding: 4px;\n}\n.font-weight-semibold {\n  margin: 17px;\n}\n.home-banner .next-btn {\n  margin-right: -46px;\n}\n.home-banner .pre-btn {\n  margin-left: -46px;\n}\n.cat-name a {\n  font-size: 24px;\n  font-weight: 500;\n  text-decoration: none;\n  color: #000;\n}\n.home-banner-img {\n  margin-top: 10px;\n}\n.container-fluid .cePreview {\n  width: 100%;\n}\n/*destop and mobile */\n.cat-img-thumbnail {\n  width: 150px;\n  height: 120px;\n}\n.col-lg-3 {\n  width: 32%;\n}\n/*custom-dropdown .dropdown-menu*/\n#avatar img {\n  /* This image is 687 wide by 1024 tall, similar to your aspect ratio */\n  /* background-image: url(\"https://i.stack.imgur.com/Dj7eP.jpg\"); */\n\n  /* make a square container */\n  width: 40px;\n  height: 40px;\n\n  /* fill the container, preserving aspect ratio, and cropping to fit */\n  background-size: cover;\n\n  /* center the image vertically and horizontally */\n  background-position: top center;\n\n  /* round the edges to a circle with border radius 1/2 container size */\n  border-radius: 50%;\n}\n.custom-dropdown .dropdown-menu a {\n  text-decoration: none;\n  color: #000;\n}\n.custom-dropdown {\n  margin-top: 10px !important;\n  margin-left: -210px !important;\n}\n.custom-dropdown .dropdown-menu {\n  width: 240px;\n  height: 280px;\n}\n\n.custom-dropdown .dropdown-menu a .icon {\n  margin-right: 15px;\n  display: inline-block;\n}\n.custom-dropdown .menu-heading {\n  font-size: 14px;\n  color: #000000;\n  padding-left: 20px;\n  padding-right: 20px;\n  cursor: text;\n  font-weight: 550;\n}\n.custom-dropdown .dropdown-menu a {\n  font-size: 14px;\n  padding: 8px 20px;\n  position: relative;\n  color: #000;\n}\n\n.custom-dropdown svg {\n  width: 25px;\n  height: 25px;\n  stroke: var(--gray-darklight);\n}\n.custom-dropdown svg:hover {\n  fill: rgb(8, 23, 71);\n  stroke: var(--Primary-Color-brand-5C6ACA);\n}\n.custom-backdrop {\n  z-index: -1;\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n.user-profile .nav-item.active,\n.user-profile .nav-item.active .nav-link {\n  font-weight: 500 !important;\n  color: var(--Primary-Color-brand-5C6ACA) !important;\n  border-bottom-color: currentcolor !important;\n  stroke: var(--Primary-Color-brand-5C6ACA) !important;\n}\n.table-responsive .img-fluid {\n  width: 100%;\n  height: 50px;\n}\n.offcanvas {\n  width: auto !important;\n}\n\n.sidebar .active {\n  color: var(--Primary-Color-Dark-000639);\n  background-color: var(--white);\n  border-radius: 6px;\n  fill: var(--Primary-Color-Dark-000639);\n  stroke: var(--Primary-Color-Dark-000639);\n  padding: 20px;\n}\n.sidebar .list-group a {\n  background: none;\n}\n.sidebar .list-group .active a {\n  color: red !important;\n}\n.rightside-bar {\n  /* height: auto !important; */\n}\n.rightside-bar .list-group-item a {\n  color: #f9fafb;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 0px;\n}\n.topmargin {\n  margin-top: 98px;\n}\n.clearBoth {\n  clear: both;\n}\n/*--------component tabel arrow------------*/\n.arrow {\n  border: solid #8d8181;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 2px;\n  margin-left: 4px;\n  cursor: pointer;\n}\n\n.right {\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n\n.left {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n}\n\n.up {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n\n.down {\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n.event-card-body h6 a,\n.event-card-body .card-text-b a {\n  color: #000;\n  text-decoration: none;\n}\n.event-card-body .card-text-b a,\n.txtBlue a {\n  color: #4983e2;\n}\n.logo img {\n  width: 85px !important;\n}\n.mdnSlCityEvents .cat-name {\n  margin-left: 30px;\n}\n.mdnSlCityEvents .text-end {\n  margin-right: 30px;\n}\n.cityPopup img {\n  width: 120px;\n  height: 120px;\n  margin-left: 10px;\n}\n.table-responsive {\n  font-size: 14px;\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n.table-responsive h1 {\n  font-size: 16px;\n}\n.table-responsive th {\n  font-size: 14px;\n  font-weight: 400;\n}\n.table-responsive .btn {\n  font-size: 14px !important;\n}\n.container {\n  min-height: 70vh;\n}\n.footer {\n}\n.mdnEDTable {\n  text-align: left !important;\n  margin-left: 20px;\n  width: 90%;\n}\n.mdnEDTable span {\n  font-weight: 600;\n}\n.modal-dialog {\n  top: 20%;\n}\n.recommend {\n  margin-top: 10px;\n}\n.mdncardTitle {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n/*----------mobile ------*/\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .event-card-body h6,\n  .event-card-body .card-text {\n    font-size: 14px;\n  }\n  .mdnCreateOrgPro .w-50 {\n    width: 100% !important;\n  }\n  .img-fluid-thumnail {\n    width: 100% !important;\n    height: 45px;\n    max-width: 80px;\n    border-radius: var(--bs-border-radius);\n  }\n  .col-lg-3 {\n    width: auto;\n  }\n  .dropdown-menu {\n    border: none !important;\n  }\n  .cat-img-thumbnail {\n    width: 100px;\n    height: 80px;\n  }\n  .cat-name a {\n    font-size: 17px;\n  }\n  .img-fluid-eventCard {\n    /*     height: auto; */\n  }\n  .img-fluid-eventCard-small {\n    border-radius: var(--bs-border-radius);\n    height: 60px;\n  }\n  .topmargin {\n    margin-top: 150px;\n  }\n  .recommend {\n    margin-top: 10px;\n  }\n  .mdnrecommend {\n    margin: 0px !important;\n    padding: 0px !important;\n  }\n  .mdnrecdviewall {\n    max-width: 120px !important;\n  }\n  .pre-btn button {\n    margin-left: -8px;\n  }\n  .next-btn button {\n    margin-right: -8px !important;\n  }\n  .ffSlider .pre-btn,\n  .ffSlider .next-btn,\n  .mdnCreateEvent {\n    display: none;\n  }\n  .mdnViewAll,\n  .mdnWelcome {\n    display: block !important;\n  }\n\n  #avatar {\n    margin-right: 12px;\n  }\n  .user-profile .nav-underline {\n    --bs-nav-underline-gap: 0rem;\n  }\n  .mdnOrgMst .rightside-bar,\n  .mdnDashboard {\n    display: none;\n  }\n  .mdnOrgMst .maincontain-width {\n    width: 100%;\n  }\n  .user-profile .nav-item {\n    padding: 0px;\n  }\n  .user-profile .nav-item button {\n    font-size: 12px;\n  }\n  .user-profile .nav-item img {\n    width: 25px;\n  }\n  .mdnSlCityEvents .cat-name {\n    margin-left: 0px;\n  }\n  .mdnSlCityEvents .text-end {\n    margin-right: 0px;\n  }\n  .cityPopup img {\n    width: 100px;\n    height: 100px;\n    padding: 4px;\n    margin: 0px;\n  }\n  .carousel-item {\n    height: 250px;\n  }\n  .carousel-inner img {\n    width: 100%;\n    height: 250px !important;\n  }\n\n  .mdnTableTitle {\n    /* width: 210% !important; */\n  }\n  .hide-on-mobile {\n    display: none;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .all-city {\n    padding: 8px !important;\n    font-size: 14px !important;\n  }\n}\n\n@media only screen and (max-width: 450px) {\n  .all-city {\n    padding: 8px !important;\n    font-size: 9px !important;\n  }\n\n  .user-profile .nav-underline {\n    --bs-nav-underline-gap: 0rem;\n  }\n  .mdnOrgMst .rightside-bar,\n  .mdnDashboard {\n    display: none;\n  }\n  .mdnOrgMst .maincontain-width {\n    width: 100%;\n  }\n  .user-profile .nav-item {\n    padding: 0px;\n  }\n  .user-profile .nav-item button {\n    font-size: 12px;\n  }\n  .user-profile .nav-item img {\n    width: 25px;\n  }\n  .cat-name a {\n    font-size: 13px;\n  }\n}\n@media only screen and (max-width: 410px) {\n  .all-city {\n    padding: 2px !important;\n    font-size: 9px !important;\n  }\n}\n@media only screen and (min-width: 600px) and (min-width: 700px) and (max-width: 900px) {\n  .order-2 {\n    order: none;\n  }\n}\n/* vertical mobile screen*/\n@media only screen and (min-width: 640px) and (max-width: 999px) {\n  .mdnViewAll,\n  .mdnWelcome {\n    display: block !important;\n  }\n  .mdnSearch {\n    position: absolute;\n    margin: 14%;\n  }\n  .topmargin {\n    margin-top: 50px;\n  }\n  .user-profile .nav-underline {\n    --bs-nav-underline-gap: 0rem;\n    margin-top: 30px;\n  }\n  .mdnOrgMst .rightside-bar,\n  .mdnDashboard {\n    display: none;\n  }\n  .mdnOrgMst .maincontain-width {\n    width: 100%;\n  }\n}\n/*\n@media only screen and (max-width: 350px) and (max-width: 600px) {\n  .topmargin {\n    margin-top: 150px;\n  }\n}*/\n\n.pencil-icon {\n  position: relative;\n  top: -23px;\n  right: -10px;\n  transform: translate(-50%, -50%);\n}\n\n.verify-button {\n  cursor: pointer;\n}\n.login-dmenu .bi::before {\n  font-size: 30px;\n}\n\n.hidden {\n  display: none;\n}\n\n.loaderBreakup {\n  width: 25px;\n  height: 25px;\n  border: 2px solid #fff;\n  border-bottom-color: #ef395f;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n  margin-top: 10px;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.event-details-container-custom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 0;\n}\n\n.event-details-left-custom {\n  display: flex;\n  flex-direction: column;\n}\n\n.tags-container-custom {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.tag-item-custom {\n  margin: 0.2rem;\n}\n\n.event-details-right-custom {\n  display: flex;\n  align-items: center;\n}\n\n.price-container-custom {\n  display: flex;\n  align-items: center;\n}\n\n.price-custom {\n  background-color: black;\n  color: white;\n  padding: 0.5rem 3rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 50px;\n  min-width: 100px;\n  margin-right: 0.5rem;\n  font-size: 18px;\n  border-radius: 5px;\n  font-weight: 550;\n}\n\n.book-btn-custom {\n  background-color: black;\n  color: white;\n  padding: 0.5rem 5rem;\n  height: 50px;\n  min-width: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n.book-btn-custom:hover {\n  background-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n}\n\n@media (max-width: 768px) {\n  .event-details-container-custom {\n    flex-direction: column;\n    align-items: flex-start;\n    /* padding-bottom: 60px; Ensure content doesn't hide behind the fixed button */\n  }\n\n  .event-details-right-custom {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: white;\n    padding: 1rem;\n    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);\n    justify-content: space-between;\n    z-index: 1000;\n  }\n\n  .price-container-custom {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .price-custom,\n  .book-btn-custom {\n    width: 48%; /* Adjust the width to ensure both elements fit side by side */\n    font-size: 14px;\n    padding: 0rem 0rem;\n  }\n\n  .mobile-view {\n    flex-direction: column; /* vertically on mobile */\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n}\n\n.org-table td {\n  text-align: left;\n  vertical-align: middle; /* Center content vertically */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
